import { Modal } from '@snsw/react-component-library';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Timeout = (_) => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  let applicationPath = queryParams.get('applicationpath');
  applicationPath = decodeURIComponent(applicationPath);

  return (
    <>
      <Modal
        title="Your session has timed out"
        buttons={[{ text: 'Continue registration', onClick: () => navigate(applicationPath) }]}
      >
        There has been no activity for the last 15 minutes.
        <br />
        For your security, you have been logged out.
      </Modal>
    </>
  );
};
